import { RelatoriosContext } from '@/contexts/RelatoriosContext';
import { Search } from 'lucide-react';
import { useContext } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  type TipoRelatorio,
  type TipoOperacao,
  type TipoDocumento,
} from '@/contexts/RelatoriosContext';

const tiposRelatorio: TipoRelatorio[] = [
  'ICMS',
  'PIS/COFINS',
  'IPI',
  'EVENTO',
  'IBS/CBS',
  'OUTROS',
];
const tiposOperacao: TipoOperacao[] = ['Todos', 'Entrada', 'Saída'];
const tiposDocumento: TipoDocumento[] = ['Todos', 'NFE', 'SAT', 'NFC'];

export function FiltroRelatorios() {
  const ctx = useContext(RelatoriosContext);
  if (!ctx) {
    throw new Error('FiltroRelatorios deve ser usado dentro de <RelatoriosProvider>');
  }

  const { filtros, setFiltros } = ctx;

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <h3 className="text-lg font-semibold text-foreground">Filtros</h3>

      <div className="grid grid-cols-1 gap-4 md:gap-6 lg:grid-cols-3 lg:gap-8">
        {/* Tipo de Relatório */}
        <div className="space-y-2">
          <Label htmlFor="tipo">Tipo de Relatório</Label>
          <Select
            value={filtros.tipoRelatorio}
            onValueChange={(value: TipoRelatorio) => setFiltros({ tipoRelatorio: value })}
          >
            <SelectTrigger id="tipo" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {tiposRelatorio.map(tipo => (
                <SelectItem key={tipo} value={tipo}>
                  {tipo}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Operação */}
        <div className="space-y-2">
          <Label htmlFor="operacao">Operação</Label>
          <Select
            value={filtros.operacao}
            onValueChange={(value: TipoOperacao) => setFiltros({ operacao: value })}
          >
            <SelectTrigger id="operacao" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {tiposOperacao.map(tipo => (
                <SelectItem key={tipo} value={tipo}>
                  {tipo}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Documento */}
        <div className="space-y-2">
          <Label htmlFor="documento">Documento</Label>
          <Select
            value={filtros.documento}
            onValueChange={(value: TipoDocumento) => setFiltros({ documento: value })}
          >
            <SelectTrigger id="documento" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {tiposDocumento.map(tipo => (
                <SelectItem key={tipo} value={tipo}>
                  {tipo}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Busca */}
      <div className="space-y-2">
        <Label htmlFor="busca">Buscar Relatório</Label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            id="busca"
            placeholder="Digite para buscar..."
            className="pl-10"
            value={filtros.busca}
            onChange={e => setFiltros({ busca: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
}
